import { Injectable, computed } from '@angular/core';

import { Observable, from } from 'rxjs';

import { BasicObjectSMI, Decision } from '@interfaces/index';
import { ConsumirApi } from '@utils/index';

@Injectable({
  providedIn: 'root'
})
export class DecisionService {

  private controlador = computed(() => 'decision');
  private api = new ConsumirApi(this.controlador());

  constructor() {}

  public obtenerTodos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`todos/${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/todos/${idEmpresa}`);
  }

  public obtenerActivos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/${idEmpresa}`);
  }

  public obtenerPorId(idEmpresa:number, idDecision: number): Observable<Decision>{
    return from(this.api.get<Decision>(`${idEmpresa}/${idDecision}`));
    // return this.http.get<decisionDTO>(`${this.apiURL}/${idEmpresa}/${idDecision}`);
  }

  public crear(registro:Decision){
    return from(this.api.post<Decision, boolean>(``,registro));
    // return this.http.post(`${this.apiURL}`, registro);
  }

  public validarNombre(registro:Decision){
    return from(this.api.post<Decision, boolean>(`validarNombre`, registro));
    // return this.http.post(`${this.apiURL}/validarNombre`, registro);
  }

  public editar(id: number, registro:Decision){
    return from(this.api.put<Decision, boolean>(`${id}`, registro));
    // return this.http.put(`${this.apiURL}/${id}`, registro);
  }

  public borrar(id:number){
    return from(this.api.delete(`${id}`));
    // return this.http.delete(`${this.apiURL}/${id}`);
  }
}